const RecreationServicesIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 8.5L15.7308 17.7804M2.48801 18.1871C4.27201 17.0651 6.99901 15.3871 7.40001 13.6851C7.52501 13.1551 7.24501 12.6421 7.00201 12.1551C5.83101 9.79706 5.80401 7.05206 7.54601 5.31306C10.584 2.27906 17.106 0.495057 20.307 3.69306C23.505 6.88606 21.722 13.4011 18.684 16.4351C16.942 18.1751 14.194 18.1491 11.834 16.9791C11.346 16.7371 10.831 16.4561 10.301 16.5811C8.59601 16.9821 6.91501 19.7051 5.79101 21.4861C4.57101 23.4211 0.634006 19.3531 2.48801 18.1871Z"
      stroke="black" strokeWidth="0.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default RecreationServicesIcon;
